"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var ABBREVIATED_DAYS = {
  monday: 'mon',
  tuesday: 'tue',
  wednesday: 'wed',
  thursday: 'thu',
  friday: 'fri',
  saturday: 'sat',
  sunday: 'sun'
};
var dayDisplayName = function dayDisplayName(day) {
  return ABBREVIATED_DAYS[day] || day;
};
var _default = exports["default"] = dayDisplayName;